import React from "react";

function SinglePageMenu(props) {
    const { currentMenuInfo } = props;

    return <div id="menuTitle">{currentMenuInfo.PGM_NAME}</div>;
}

export default SinglePageMenu;
